import { useEffect } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Login from '../components/auth/Login';

const Auth = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Redirect authenticated users
  useEffect(() => {
    if (currentUser) {
      const redirectUrl = getRedirectUrl();
      navigate(redirectUrl, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, navigate, searchParams]);

  // Get redirect URL from query parameter or location state
  const getRedirectUrl = () => {
    // Priority 1: Explicit redirect param (for coach platform, etc.)
    const redirectParam = searchParams.get('redirect');
    if (redirectParam) {
      return decodeURIComponent(redirectParam);
    }

    // Priority 2: Protected route redirect (location state)
    if (location.state?.from?.pathname) {
      return location.state.from.pathname;
    }

    // Priority 3: Always go to dashboard
    return '/dashboard';
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 overflow-x-hidden"
      style={{
        background: `
          linear-gradient(45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
          linear-gradient(-45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
          linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.05) 75%),
          linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.05) 75%),
          linear-gradient(to bottom, #1a1a1a 0%, #0d0d0d 90%)
        `,
        boxShadow: 'inset 0 2px 12px rgba(12, 10, 10, 0.6)'
      }}
    >
      <div className="max-w-md w-full space-y-6">
        {/* ChessWeb.site Logo */}
        <div className="flex justify-center items-center space-x-3">
          <img
            src="/Images/ChessWeb.site.png"
            alt="ChessWeb.site"
            className="h-12 w-12"
            style={{ borderRadius: '5px' }}
          />
          <span className="text-lg font-medium text-white">
            ChessWeb.site
          </span>
        </div>

        <Login redirectUrl={getRedirectUrl()} />
      </div>
    </div>
  );
};

export default Auth; 